//TODO: Adjust minimum size of birds in view here
export const MIN_APPARENT_SIZE = 0.1; // Minimum size of bird in view
export const MIN_APPARENT_SIZE_FLYING = 0.01; // Minimum size of bird in view when flying
export const MAX_APPARENT_SIZE = 0.8; // Maximum size of bird in view

export const USE_SHADOWS = false;
// Place one instance of each bird next to each other for testing
export const TEST_PLACEMENT = false;

export const RENDER_CONSTANTS = {
  LOCK_DEBOUNCE: 1500,
  // Distance threshold for rendering terrain details
  VISIBILITY_THRESHOLD: 100,
  FOREST_WATER_Y_POSITION: -9.5, // Y value of water surface in forest
  WETLAND_WATER_Y_POSITION: -3.25 // Y value of water surface in wetland
};

//TODO: Adjust these values to change the zoom stages of the camera
export const ZOOM_VALUES = {
  PHOTOGRAPHY: 2,
  PHOTOGRAPHY_ZOOMED: 5,
  DEFAULT: 1
};

export const GAME_STATUS = {
  // default playing state
  DEFAULT: "DEFAULT",
  // paused state
  PAUSED: "PAUSED",
  // viewing through camera state
  PHOTOGRAPHY: "PHOTOGRAPHY",
  // viewing through camera state, zoomed in
  PHOTOGRAPHY_ZOOMED: "PHOTOGRAPHY_ZOOMED"
};

export const ENVIRONMENTS = {
  FOREST: "forest",
  WETLAND: "wetland"
};

/**
 * Enum for different types of bird positions
 */
//  Commenting out for MVP -- flying is true or false for now
export const BIRD_POSITION_TYPES = {
  GROUND: "GROUND",
  FLYING: "FLYING",
  PERCHED: "PERCHED",
  SWIMMING: "SWIMMING"
};
